var map = {
	"./decidim/avatar-multiuser.png": 19622,
	"./decidim/brands/facebook.svg": 44912,
	"./decidim/brands/google.svg": 63881,
	"./decidim/brands/twitter-x.svg": 46434,
	"./decidim/cc-badge.png": 80568,
	"./decidim/decidim-logo.svg": 78884,
	"./decidim/default-avatar.svg": 51452,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 31976,
	"./decidim/icons.svg": 7255,
	"./decidim/pattern.png": 2552,
	"./decidim/placeholder-card-g.svg": 60221,
	"./decidim/placeholder-card-l.svg": 92182,
	"./decidim/placeholder.jpg": 18965,
	"./decidim/remixicon.symbol.svg": 28697,
	"./decidim/vendor/social-share-button/douban.svg": 504,
	"./decidim/vendor/social-share-button/email.svg": 1141,
	"./decidim/vendor/social-share-button/facebook.svg": 51883,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 23717,
	"./decidim/vendor/social-share-button/hacker_news.svg": 88709,
	"./decidim/vendor/social-share-button/linkedin.svg": 35725,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 15038,
	"./decidim/vendor/social-share-button/pinterest.svg": 99627,
	"./decidim/vendor/social-share-button/reddit.svg": 27711,
	"./decidim/vendor/social-share-button/telegram.svg": 9362,
	"./decidim/vendor/social-share-button/tumblr.svg": 41329,
	"./decidim/vendor/social-share-button/twitter.svg": 8279,
	"./decidim/vendor/social-share-button/vkontakte.svg": 74650,
	"./decidim/vendor/social-share-button/wechat.svg": 1189,
	"./decidim/vendor/social-share-button/whatsapp.svg": 62485,
	"./decidim/vendor/social-share-button/x.svg": 99541,
	"./decidim/vendor/social-share-button/xing.svg": 45195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39869;